import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};


// Controller
const getControlleClient = async () => {
    try {
        const resp = await fetch(`/api/app/controller/`, {
            method: "GET",
            headers: {
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBannerClient = async () => {
    try {
        const resp = await fetch(`/api/app/banner`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBannerClickClient = async (id) => {
    try {
        const resp = await fetch(`/api/app/banner/click/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReelsClient = async (page, limit) => {
    try {
        const resp = await fetch(`/api/app/story?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const viewPluseReelsClient = async (id) => {
    try {
        const resp = await fetch(`/api/app/story/view/${id}`, {
            method: "POST",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getCategoryClient = async (page, limit) => {
    try {
        const resp = await fetch(`/api/app/category/get/all?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getCategoryClientByID = async (page, limit, id) => {
    try {
        const resp = await fetch(`/api/app/category/${id}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getProductClientByID = async (id) => {
    try {
        const resp = await fetch(`/api/app/list/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getPrompotClientByID = async (id) => {
    try {
        const resp = await fetch(`/api/app/list/prompt/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Client
const setNotificationServer = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/token`, {
            method: "POST",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Search
const searchBar = async (q, page, limit) => {
    try {
        const resp = await fetch(`/api/app/list/by/search?q=${q}&page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// CateAll List
const getCategoryList = async () => {
    try {
        const resp = await fetch(`/api/app/category/list/all`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Suggestion
const sendSuggestion = async (body) => {

    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/suggestion/send`, {
            method: "POST",
            headers: {

                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog
const getBlog = async (page, limit) => {

    try {
        const resp = await fetch(`/api/app/blog/web?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBlogId = async (id) => {

    try {
        const resp = await fetch(`/api/app/blog/web/${id}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBlogSearch = async (q) => {

    try {
        const resp = await fetch(`/api/app/blog/search?query=${q}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog Rendom
const getBlogRendom = async () => {
    try {
        const resp = await fetch(`/api/app/blog/random`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog By Title
const getBlogByTitle = async (id) => {
    try {
        const resp = await fetch(`/api/app/blog/web/title/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


const ClientCalling = {
    getControlleClient,
    getBannerClient,
    getBannerClickClient,
    getReelsClient,
    viewPluseReelsClient,
    getCategoryClient,
    getCategoryClientByID,
    getProductClientByID,
    getPrompotClientByID,
    setNotificationServer,
    searchBar,
    getCategoryList,
    sendSuggestion,
    getBlog, getBlogId, getBlogSearch, getBlogByTitle, getBlogRendom
}

export default ClientCalling;